const contact = {
  header: {
    overline: "PRENONS CONTACT",
    titlePrefix: "Construisons la",
    titleHighlight: "prochaine grande idée",
    titleSuffix: "ensemble",
    subtitle:
      "Vous avez un challenge data complexe ou un projet IA ambitieux ? Je vous apporte expertise technique et guidance stratégique pour le concrétiser.",
  },
  benefits: ["Réponse sous 24h", "Échange direct avec un expert", "Focus architecture scalable", "Solutions IA prêtes production"],
  form: {
    title: "Message rapide",
    fullName: "Nom complet",
    email: "Adresse email",
    phone: "Numéro de téléphone",
    subject: "Sujet",
    details: "Détails du projet",
    submit: {
      idle: "Envoyer la demande",
      loading: "Envoi en cours...",
    },
  },
  info: {
    linkedin: { label: "LinkedIn", value: "Alexandre SANOU" },
    location: { label: "Localisation", value: "Île-de-France / Remote" },
  },
  footer: {
    titlePrefix: "Transformer vos défis en",
    titleHighlight: "avantages compétitifs",
    subtitle:
      "Je ne me contente pas de coder : je conçois des systèmes intelligents qui créent de la croissance. Discutons de la manière dont mon expertise en Data Science et développement Full‑Stack peut servir votre prochain projet.",
  },
  modal: {
    successTitle: "Succès !",
    errorTitle: "Erreur",
    close: "Fermer",
    successMessage:
      "🚀 Session stratégique demandée ! Ravi de vous accompagner, {{name}}. Je vous recontacte sous 24h.",
    errorMessage: "Une erreur est survenue. Veuillez réessayer plus tard.",
  },
};

export default contact;
